<template>
  <div class="join-line">
    <a class="btn btn-join btn-line d-flex align-items-center mx-1" href="https://line.me/R/ti/p/@gbi0903c"
      target="_blank">
      <i class="fab fa-line"></i>
      加入酒訊好友
    </a>
  </div>
</template>
<style lang="scss" scoped>
.right-line-box {
  color: #000;
  position: fixed;
  right: 10px;
  bottom: 100px;
  z-index: 99;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  width: 200px;
  height: 200px;
  display: flex;
}

.btn-join {
  background-color: #06c755;
  color: white;
  border: none;
  border-radius: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
